import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { BadMoodStreakTask } from "../../taskbook.types";
import { LinkPreview, GifPreview, TimelineItem, Threads } from "@teammood/timeline";

@Component({
    selector: 'bad-mood-streak-task',
    templateUrl: './bad-mood-streak-task.component.html',
    styleUrls: ['./../task.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BadMoodStreakTaskComponent {

    @Input() task: BadMoodStreakTask;
    @Output() onComment = new EventEmitter()

    comment(){
        this.onComment.emit('');
    }

    achive(){
        this.task = undefined
    }
    
}


